// extracted by mini-css-extract-plugin
export default {"root":"Arrow_root__xEW-4"};